import styled from "styled-components";
import { COLORS } from "../../constants/colors";
import { LoadingIcon } from "../../constants/cssElements";

interface IMessage{
    message?: string;
}

const Label = styled.div<any>`
    
    font-weight: bold;
    font-size: x-large;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    padding-top: 8em;
    
    h2{
        color:var(--black_text_color3);
        font-size: large;
    }

    
`;

const LoadingPage: React.FC<IMessage> = ({message})=>{
    return(
        <Label>
            <LoadingIcon className='loading-icon LoadingPage-icon' color={COLORS.blue_third} size={'3em'} />
            <h2>{message}</h2>
        </Label>
    )
}

export default LoadingPage;